export type SimplecastPodcastType = {
  title: string;
  description: string;
  image_url: string;
  id: string;
  distribution_channels: {
    href: string;
  };

  channels: ChannelType[];
};

export type ChannelType = {
  href: string;
  url: string;
  id: string;
  distribution_channel: {
    href: string;
    name: string;
    id: string;
  };
};

export type PodcastType = {
  image_url: string;
  id: string;
  title: string;
  description: string;
  channels: ChannelType[];
};

export enum EpisodeStatus {
  PUBLISHED = 'published',
  DRAFT = 'draft',
}

export type EpisodeType = {
  id: string;
  title: string;
  description: string;
  number: number;
  published_at: string;
  status: EpisodeStatus;
  slug: string;
};

export type DetailedEpisodeType = EpisodeType & {
  audio_file_url: string;
  transcription: string;
};

export enum SimpleCastStore {
  PODCAST = 'podcast',
  EPISODES = 'episodes',
}
